<template>
    <div>
        <h3 class="title is-4">NISCC Information</h3>
        
        <div v-if="loading == true" class="notification is-warning">
            Loading ...
        </div>

        <div v-if="loading==false">
            

            <div class="field">
                <label class="label">NISCC Number</label>
                <div class="control">
                    <input class="input" type="text" v-model="member.niscc_number" >
                </div>
            </div>

            <div class="field">
                <label class="label">NISCC Registered On</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.niscc_registered" >
                </div>
            </div>
            
            <div class="field">
                <label class="label">NISCC Expiry Date</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.niscc_expiry" >
                </div>
            </div>

            <div class="field">
                <label class="label">Last Checked On</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.niscc_last_checked" disabled readonly>
                </div>
            </div>

            <div class="field ">
                <div class="control">
                    <button class="button is-success" :disabled="working===true" @click="updateNiscc()">Update Details</button>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
import MemberMixin from '@/mixins/MemberMixin.js';

import MemberService from '@/services/MemberService.js';

export default {
    name: 'MemberNiscc',
  data() {
    return {
      count: 0,
      loading: false,
      working: false
    }
  },
  mixins: [MemberMixin],
  props: ['member'],
  methods: {
        
        async updateNiscc() {
			this.working = true
            var formdata = { 
                _method: 'patch',
                niscc_number: this.member.niscc_number,
                niscc_registered: this.member.niscc_registered,
                niscc_expiry: this.member.niscc_expiry
            }; 

            MemberService.updateMember(this.accessToken, formdata, this.member.id)
            .then((response) => {
                this.$emit('reload-member')
                console.log(response)
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
        },
        
        
    },
    created() {
            this.getAccessToken()
            .then(() => { 
                
            });
        
        },
}
</script>